import { queryOptions } from '@tanstack/react-query';
import { documentKeys } from '@shared/api/query-keys';
import type { DocumentSearchParams } from '@api/types/document';
import { documentsApi } from './documents';

type Id = string | number;

/**
 * Co-located `queryOptions` for the documents domain (Server-state rebuild, P3). Key +
 * queryFn defined once; hooks add per-call overrides (`enabled`, `refetchInterval`,
 * `staleTime`). `getQueryData(documentQueries.editor(a, id).queryKey)` is typed for free.
 */
export const documentQueries = {
  detail: (auditId: string, documentId: Id) =>
    queryOptions({
      queryKey: documentKeys.detail(auditId, documentId),
      queryFn: () => documentsApi.getDocument(auditId, String(documentId)),
    }),
  editor: (auditId: string, documentId: Id) =>
    queryOptions({
      queryKey: documentKeys.editor(auditId, documentId),
      queryFn: () => documentsApi.getDocumentEditor(auditId, documentId),
    }),
  annotationHistory: (auditId: string, documentId: Id) =>
    queryOptions({
      queryKey: documentKeys.annotationHistory(auditId, documentId),
      queryFn: () => documentsApi.getAnnotationHistory(auditId, documentId),
    }),
  metaTypes: (auditId: string) =>
    queryOptions({
      queryKey: documentKeys.metaTypes(auditId),
      queryFn: () => documentsApi.getDocumentTypes(auditId),
    }),
  list: (auditId: string, params?: DocumentSearchParams) =>
    queryOptions({
      queryKey: documentKeys.list(auditId, params),
      queryFn: () => documentsApi.getDocumentBacklinks(auditId, params),
    }),
  deletedList: (auditId: string, params?: DocumentSearchParams) =>
    queryOptions({
      queryKey: documentKeys.deletedList(auditId, params),
      queryFn: () => documentsApi.getDeletedDocuments(auditId, params),
    }),
};
